import { render, staticRenderFns } from "./MinuteEditPage.vue?vue&type=template&id=08240a12&"
import script from "./MinuteEditPage.vue?vue&type=script&lang=ts&"
export * from "./MinuteEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports